import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createOffer as createOfferApi } from "../../../../services/dashboard/apiOffers";
import toast from "react-hot-toast";

function useCreateOffer() {
  const queryClient = useQueryClient();

  const {
    mutate: createOffer,
    isPending: isCreating,
    error,
  } = useMutation({
    mutationFn: createOfferApi,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["offers"],
      });

      toast.success("تم أنشاء العرض بنجاح");
    },

    onError: (error) => {
      toast.error(error.response.data.message);
    },
  });

  return { createOffer, isCreating, error };
}

export default useCreateOffer;
